module.exports = __webpack_public_path__ + "static/media/bill-bottom.7ec7e330.jpg";